import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, DateField } from './util';
import { Team } from './team';
import { TournamentTeamUser } from './tournament-team-user';
import { TeamUser } from './team-user';
import { TournamentTeam } from './tournament-team';
import { User } from './user';
import { BaseStatistic, WinLoseType } from './base-statistic';
import { LeaguePlayer } from './league-player';

@ModelInstance({
  mappingFields: {
    team: 'team',
    team_user: 'teamUser',
    league_player: 'leaguePlayer',
    tournament_team_user: 'tournamentTeamUser',
    tournament_team: 'tournamentTeam',
    user: 'user',
    month: 'month',
    win_lose: 'winLose',
    games_count: 'gamesCount',
    won_games_count: 'wonGamesCount',
    team_score_sum: 'teamScoreSum',
    team_missed_sum: 'teamMissedSum',
    tournament_points: 'tournamentPoints',
    serve_hits: 'serveHits',
    serve_faults: 'serveFaults',
    serve_aces: 'serveAces',
    serve_percent: 'servePercent',
    good_serves: 'goodServes',
    ace_percent: 'acePercent',
    stuff_blocks: 'stuffBlocks',
    block_faults: 'blockFaults',
    block_rebounds: 'blockRebounds',
    block_percent: 'blockPercent',
    attack_spikes: 'attackSpikes',
    attack_faults: 'attackFaults',
    attack_shots: 'attackShots',
    attack_percent: 'attackPercent',
    receives: 'receives',
    receive_faults: 'receiveFaults',
    excellent_receives: 'excellentReceives',
    receive_percent: 'receivePercent',
    serve_receives: 'serveReceives',
    serve_receive_faults: 'serveReceiveFaults',
    excellent_serve_receives: 'excellentServeReceives',
    serve_receive_percent: 'serveReceivePercent',
    points: 'points',
    faults: 'faults',
    newbie: 'newbie',
    rank: 'rank',
  },
  relation: {
    team: Team,
    teamUser: TeamUser,
    leaguePlayer: LeaguePlayer,
    tournamentTeamUser: TournamentTeamUser,
    tournamentTeam: TournamentTeam,
    user: User,
    month: DateField,
  }
})
export class VolleyballStatistic extends BaseModel implements BaseStatistic {
  leaguePlayer: LeaguePlayer;
  tournamentTeamUser: TournamentTeamUser;
  team: Team;
  teamUser: TeamUser;
  user: User;
  tournamentTeam: TournamentTeam;
  month: Date;
  winLose: WinLoseType;
  gamesCount: number;
  wonGamesCount: number;
  teamScoreSum: number;
  teamMissedSum: number;
  tournamentPoints: number;
  newbie: boolean;
  rank: number;
  serveHits: number;
  serveFaults: number;
  serveAces: number;
  goodServes: number;
  servePercent: number;
  acePercent: number;
  stuffBlocks: number;
  blockFaults: number;
  blockRebounds: number;
  blockPercent: number;
  attackSpikes: number;
  attackFaults: number;
  attackShots: number;
  attackPercent: number;
  receives: number;
  receiveFaults: number;
  excellentReceives: number;
  receivePercent: number;
  serveReceives: number;
  serveReceiveFaults: number;
  excellentServeReceives: number;
  serveReceivePercent: number;
  points: number;
  faults: number;

  get tournamentTeamPoints(): number {
    return this.tournamentTeam && this.tournamentTeam.points;
  }

  get totalReceives(): number {
    return Math.floor(10 * (this.receives + this.excellentReceives + this.receiveFaults)) / 10;
  }

  get totalServeReceives(): number {
    return Math.floor(10 * (this.serveReceives + this.excellentServeReceives + this.serveReceiveFaults)) / 10;
  }

  get totalServes(): number {
    return Math.floor(10 * (this.serveAces + this.serveHits + this.serveFaults + this.goodServes)) / 10;
  }

  get totalAttacks(): number {
    return Math.floor(10 * (this.attackSpikes + this.attackShots + this.attackFaults)) / 10;
  }

  get totalBlocks(): number {
    return Math.floor(10 * (this.stuffBlocks + this.blockRebounds + this.blockFaults)) / 10;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
